module.exports = __webpack_public_path__ + "public/files/img/logo.a8a4c37a.png";